import React from 'react';
import { Check, Sparkles, Clock } from 'lucide-react';
const PURCHASE_LINK = 'https://pay.hotmart.com/R104011320A?off=notbkezu&checkoutMode=10';
export function PricingCard() {
  return <div className="relative w-full max-w-md mx-auto" data-id="element-13">
      {/* Floating Badge */}
      <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-yellow-400 text-black font-bold py-2 px-6 rounded-full shadow-lg z-10 flex items-center gap-2 whitespace-nowrap border-2 border-white transform hover:scale-105 transition-transform" data-id="element-14">
        <Sparkles className="w-5 h-5" data-id="element-15" />
        <span data-id="element-16">80% OFF TODAY ONLY</span>
      </div>

      <div className="bg-white rounded-3xl shadow-2xl border-4 border-pink-100 overflow-hidden relative" data-id="element-17">
        {/* Header */}
        <div className="bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 p-8 text-center text-white pt-10" data-id="element-18">
          <h3 className="text-2xl font-bold mb-2" data-id="element-19">Mega Template Bundle</h3>
          <p className="opacity-90 font-medium" data-id="element-20">
            Everything you need to start selling
          </p>
        </div>

        {/* Pricing Body */}
        <div className="p-8 text-center" data-id="element-21">
          <div className="flex items-center justify-center gap-4 mb-2" data-id="element-22">
            <span className="text-gray-400 text-2xl font-medium line-through decoration-red-500 decoration-2" data-id="element-23">
              $179.99
            </span>
            <div className="bg-green-100 text-green-700 font-bold px-3 py-1 rounded-lg text-sm" data-id="element-24">
              SAVE $150
            </div>
          </div>

          <div className="flex items-start justify-center gap-1 mb-6" data-id="element-25">
            <span className="text-4xl font-bold text-gray-800 mt-2" data-id="element-26">$</span>
            <span className="text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600" data-id="element-27">
              29.99
            </span>
            <span className="text-xl font-medium text-gray-500 mt-8" data-id="element-28">USD</span>
          </div>

          {/* Urgency Timer Placeholder */}
          <div className="flex items-center justify-center gap-2 text-red-500 font-semibold mb-8 bg-red-50 py-2 rounded-lg" data-id="element-29">
            <Clock className="w-5 h-5" data-id="element-30" />
            <span data-id="element-31">Offer ends soon!</span>
          </div>

          {/* Features List */}
          <ul className="space-y-4 text-left mb-8" data-id="element-32">
            {['15,000+ Editable Pages', '8,000+ Digital Stickers', 'Resell Rights Included (PLR)', 'Keep 100% of Profits', 'Lifetime Access', 'Instant Download'].map((feature, i) => <li key={i} className="flex items-center gap-3" data-id="element-33">
                <div className="bg-purple-100 p-1 rounded-full text-purple-600 flex-shrink-0" data-id="element-34">
                  <Check className="w-4 h-4" data-id="element-35" />
                </div>
                <span className="text-gray-700 font-medium" data-id="element-36">{feature}</span>
              </li>)}
          </ul>

          {/* CTA Button */}
          <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold text-xl py-4 rounded-xl shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all active:scale-95 animate-pulse-slow" data-id="element-37">
            Get Instant Access
          </a>

          <p className="text-xs text-gray-400 mt-4" data-id="element-38">
            Secure payment • Instant digital delivery
          </p>
        </div>
      </div>
    </div>;
}